const POPUP_LINK_NAME = 'popup-link';

class PopupLink extends HTMLAnchorElement {
    constructor() {
        super();

        this._windowPopUp = this._windowPopUp.bind(this);
    }

    connectedCallback() {
        this._popupHeight = 600;
        this._popupWidth = 600;

        this.addEventListener('click', this._windowPopUp);
    }

    disconnectedCallback() {
        this.removeEventListener('click', this._windowPopUp);
    }

    _windowPopUp(event) {
        event.preventDefault();

        const top = (screen.height - this._popupHeight) / 2;
        const left = (screen.width - this._popupWidth) / 2;
        const features = `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=${this._popupWidth},height=${this._popupHeight},top=${top},left=${left}`;

        window.open(this.getAttribute('href'), '', features);
    }
}

customElements.define(POPUP_LINK_NAME, PopupLink, { extends: 'a' });
